<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M16.862 23.46l6.46-6.46H6.332a1 1 0 110-2H23.32l-6.46-6.46a1 1 0 011.415-1.414l8.049 8.049a1.167 1.167 0 010 1.65l-8.05 8.048a1 1 0 11-1.413-1.414z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'arrowsRightOutline'
}
</script>
